export class CompanyBillingGroup {
    id = null;

    description = '';
}
